var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light/Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.2125 24.1625C26.2125 24.6125 26.1125 25.075 25.9 25.525C25.6875 25.975 25.4125 26.4 25.05 26.8C24.4375 27.475 23.7625 27.9625 23 28.275C22.25 28.5875 21.4375 28.75 20.5625 28.75C19.2875 28.75 17.925 28.45 16.4875 27.8375C15.05 27.225 13.6125 26.4 12.1875 25.3625C10.75 24.3125 9.3875 23.15 8.0875 21.8625C6.8 20.5625 5.6375 19.2 4.6 17.775C3.575 16.35 2.75 14.925 2.15 13.5125C1.55 12.0875 1.25 10.725 1.25 9.425C1.25 8.575 1.4 7.7625 1.7 7.0125C2 6.25 2.475 5.55 3.1375 4.925C3.9375 4.1375 4.8125 3.75 5.7375 3.75C6.0875 3.75 6.4375 3.825 6.75 3.975C7.075 4.125 7.3625 4.35 7.5875 4.675L10.4875 8.7625C10.7125 9.075 10.875 9.3625 10.9875 9.6375C11.1 9.9 11.1625 10.1625 11.1625 10.4C11.1625 10.7 11.075 11 10.9 11.2875C10.7375 11.575 10.5 11.875 10.2 12.175L9.25 13.1625C9.1125 13.3 9.05 13.4625 9.05 13.6625C9.05 13.7625 9.0625 13.85 9.0875 13.95C9.125 14.05 9.1625 14.125 9.1875 14.2C9.4125 14.6125 9.8 15.15 10.35 15.8C10.9125 16.45 11.5125 17.1125 12.1625 17.775C12.8375 18.4375 13.4875 19.05 14.15 19.6125C14.8 20.1625 15.3375 20.5375 15.7625 20.7625C15.825 20.7875 15.9 20.825 15.9875 20.8625C16.0875 20.9 16.1875 20.9125 16.3 20.9125C16.5125 20.9125 16.675 20.8375 16.8125 20.7L17.7625 19.7625C18.075 19.45 18.375 19.2125 18.6625 19.0625C18.95 18.8875 19.2375 18.8 19.55 18.8C19.7875 18.8 20.0375 18.85 20.3125 18.9625C20.5875 19.075 20.875 19.2375 21.1875 19.45L25.325 22.3875C25.65 22.6125 25.875 22.875 26.0125 23.1875C26.1375 23.5 26.2125 23.8125 26.2125 24.1625Z",
    stroke: "#FF7F29",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.875 12.5C21.875 11.75 21.2875 10.6 20.4125 9.6625C19.6125 8.8 18.55 8.125 17.5 8.125",
    stroke: "#FF7F29",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.25 12.5C26.25 7.6625 22.3375 3.75 17.5 3.75",
    stroke: "#FF7F29",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOrange);
export default __webpack_public_path__ + "static/media/phoneOrange.c4ba5af6c7ec31bc3a0433fbb4153a6f.svg";
export { ForwardRef as ReactComponent };